import "./BarcodesListScreen.scss";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {useDispatch, useSelector} from "react-redux";
import BarcodesListTableComponent from "./barcodes-list-table/BarcodesListTableComponent";
import SearchComponent from "../../shared/components/search/SearchComponent";
import _ from "lodash";
import DownloadIcon from "@mui/icons-material/Download";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import {AttachFile, Download} from "@mui/icons-material";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import FormikInputComponent from "../../shared/components/core/formik-input/FormikInputComponent";
import FormikAutoCompleteDropdown
    from "../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import Grid from "@mui/material/Grid";
import ErrorComponent from "../../shared/components/form-controls/error/errorComponent";
import ChipComponent from "../../shared/components/chip/ChipComponent";
import DialogComponent from "../../shared/components/dialog/dialogComponent";
import {CommonService} from "../../shared/services";
import {IAPIResponseType} from "../../shared/models/api.model";
import commonService from "../../shared/services/common.service";
import {IRootReducerState} from "../../store/reducers";
import * as Yup from "yup";

interface BarcodesComponentProps {

}

const FiltersInitialState: any = {
    search: '',
}
const bulkUploadValidationSchema = Yup.object({
    title: Yup.string().required('Title is required.').nullable(),
    test: Yup.mixed().required('Test is required.').nullable(),
    file: Yup.mixed().required('File is required').nullable(),
});

interface bulkUploadFormSchema {
    title: string,
    test: any,
    file: any,
}

const bulkUploadFormInitialValues: bulkUploadFormSchema = {
    title: "",
    test: null,
    file: null,
}

const validationSchema = Yup.object({
    testId: Yup.mixed().required('Test Name is required').nullable(),
    quantity: Yup.string().required('No of barcodes is required'),
});

interface BarcodeDownloadFormSchema {
    testId: any;
    quantity: string;
}

const formInitialValues: BarcodeDownloadFormSchema = {
    testId: null,
    quantity: ''
}

const MODULE_NAME = 'barcode-list-table'

const BarcodesListScreen = (props: BarcodesComponentProps) => {

    const dispatch = useDispatch();
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const [isImportDrawerOpen, setIsImportDrawerOpen] = React.useState<boolean>(false);
    const {testListLite} = useSelector((state: IRootReducerState) => state.staticData);
    const excelFileRef = useRef<HTMLInputElement | null>(null);
    const [bulkUploadInitialValues] = useState<bulkUploadFormSchema>(bulkUploadFormInitialValues);
    const formikRef = useRef<any>(null)
    const [openDownloadDialog, setOpenDownloadDialog] = useState<boolean>(false);
    const [downloadBarCodeDetailsFormInitialValues] = useState<BarcodeDownloadFormSchema>(formInitialValues);


    useEffect(() => {
        dispatch(setCurrentNavParams("Barcode", "Barcode"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    const handleExcelAttachmentUpload = useCallback((event: any) => {
        const file = event?.target?.files[0];
        if (formikRef.current) {
            formikRef.current.setFieldValue('file', file);
        }
    }, []);

    const onFormSubmit = useCallback((values: any, {
        setSubmitting,
        setErrors,
        validateForm
    }: FormikHelpers<any>) => {
        const payload = {
            testId: values.test?.id,
            file: values?.file,
            title: values?.title
        };
        const formData = CommonService.getFormDataFromJSON(payload);
        setSubmitting(true);
        CommonService._barcode.uploadBulkBarcodes(formData)
            .then((response: IAPIResponseType<any>) => {
                setSubmitting(false);
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: MODULE_NAME
                });
                setIsImportDrawerOpen(false)
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            })
    }, []);

    const onSubmit = useCallback((values: any, {
        setSubmitting,
    }: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = {
            quantity: values?.quantity
        }
        commonService._barcode.downloadBarcodes(values?.testId?.id, payload)
            .then((response) => {
                    setSubmitting(false);
                    commonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title, response?.data?.type)
                    setOpenDownloadDialog(false)
                }
            )
            .catch((error) => {
                setSubmitting(false);
            })
    }, [])

    return (
        <div className="barcodes-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search"}
                                placeholder={"Search Biomarker"}
                                id="search_input"
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            <ButtonComponent
                                type="button"
                                color={"primary"}
                                variant={"contained"}
                                id="add_bulk_test_order_button"
                                handleClick={() => {
                                    setIsImportDrawerOpen(true)
                                }}
                                startIcon={<DownloadIcon/>}
                            >
                                Import XLS
                            </ButtonComponent>
                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"secondary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => {
                                    setOpenDownloadDialog(true)
                                }}
                                startIcon={<Download/>}
                            >
                                Download Barcodes
                            </ButtonComponent>
                        </div>
                    </div>
                </div>
                {/*<BarcodesSystemGeneratedListComponent/>*/}
                <BarcodesListTableComponent filterData={filterData}/>

                <DrawerComponent open={isImportDrawerOpen}
                                 className={"drawer-wrapper"}
                                 closeOnBackDropClick={true}
                                 closeOnEsc={true}
                                 title={"Import Barcode File"}
                                 onClose={() => setIsImportDrawerOpen(false)}
                >
                    <div className={'screen t-form-screen import-bulk-barcodes-drawer'}>
                        <div className={'t-form t-form-drawer'}>
                            <Formik
                                validationSchema={bulkUploadValidationSchema}
                                initialValues={bulkUploadInitialValues}
                                enableReinitialize={true}
                                onSubmit={onFormSubmit}
                                innerRef={formikRef}
                            >
                                {({isSubmitting, values, isValid, touched, setFieldValue, validateForm, errors}) => {
                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                    useEffect(() => {
                                        validateForm();
                                    }, [validateForm, values, errors]);
                                    return (
                                        <Form noValidate={true}>
                                            <div className="t-form-controls-wrapper mrg-top-20">
                                                <Field name={'title'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Title'}
                                                                placeholder={'Enter title'}
                                                                required={true}
                                                                multiline={false}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                                <Field
                                                    name={'test'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikAutoCompleteDropdown
                                                                label={'Ordered Test'}
                                                                formikField={field}
                                                                data={testListLite}
                                                                valueKey={"id"}
                                                                required={true}
                                                                placeholder={"Select Test Name"}
                                                                getOptionLabel={(option => (option.name) || '')}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                                <div className="attachment-upload-wrapper">
                                                    <div className="attachment-upload-list">
                                                        <div className="attachment-upload-item">
                                                            <div
                                                                className="attachment-upload-item-title">
                                                                Bulk Barcode File
                                                            </div>
                                                            {!values.file ? <>
                                                                    <input type={"file"}
                                                                           className={"display-none"}
                                                                           ref={excelFileRef}
                                                                           accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                                           onChange={(event) => {
                                                                               handleExcelAttachmentUpload(event);
                                                                           }}
                                                                    />
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={12} sm={6} md={6}>
                                                                            <ButtonComponent
                                                                                variant={"outlined"}
                                                                                fullWidth={true}
                                                                                color={'secondary'}
                                                                                handleClick={() => {
                                                                                    excelFileRef.current?.click()
                                                                                }}
                                                                                type={'button'}>
                                                                                Upload
                                                                            </ButtonComponent>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={6} md={6}>
                                                                        </Grid>
                                                                    </Grid>
                                                                    {
                                                                        (_.get(touched, "file") && !!(_.get(errors, "file"))) &&
                                                                        <ErrorComponent
                                                                            errorText={(_.get(errors, "file"))}/>
                                                                    }
                                                                </>
                                                                : <div className={'bulk-test-order-file'}>
                                                                    <ChipComponent
                                                                        label={values.file?.name}
                                                                        onDelete={() => {
                                                                            setFieldValue("file", null);
                                                                        }}
                                                                        icon={<AttachFile/>}
                                                                    />
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="drawer-actions form-action-section">
                                                <ButtonComponent variant={"contained"}
                                                                 fullWidth={true}
                                                                 type={'submit'}
                                                                 isLoading={isSubmitting}
                                                                 disabled={!isValid}
                                                                 color={"primary"}>
                                                    Proceed
                                                </ButtonComponent>
                                            </div>
                                        </Form>
                                    )
                                }}
                            </Formik>
                        </div>
                    </div>
                </DrawerComponent>
                <DialogComponent
                    open={openDownloadDialog}
                    direction={"down"}
                    isShowCancel={false}
                    maxWidth={'sm'}
                >
                    <div className={'barcodes-download-dialog-wrapper'}>
                        <div className={'download-dialog-title'}>Download Barcodes</div>
                        <Formik
                            validationSchema={validationSchema}
                            initialValues={downloadBarCodeDetailsFormInitialValues}
                            enableReinitialize={true}
                            onSubmit={onSubmit}
                        >
                            {({isSubmitting, values, isValid, errors, setFieldValue, validateForm, resetForm}) => {
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                useEffect(() => {
                                    validateForm();
                                }, [validateForm, values]);
                                return (
                                    <Form noValidate={true}>
                                        <Field
                                            name={'testId'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikAutoCompleteDropdown
                                                        label={'Select Test Name'}
                                                        formikField={field}
                                                        data={testListLite}
                                                        valueKey={"id"}
                                                        required={true}
                                                        placeholder={"Select Test Name"}
                                                        getOptionLabel={(option => (option.name) || '')}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <Field name={'quantity'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'Number of Barcodes'}
                                                        placeholder={'Enter Number of Barcodes'}
                                                        type={"text"}
                                                        required={true}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <div className={'dialog-action-section'}>
                                            <ButtonComponent
                                                type="button"
                                                color={"primary"}
                                                variant={"outlined"}
                                                fullWidth={true}
                                                handleClick={() => {
                                                    resetForm();
                                                    setOpenDownloadDialog(false)
                                                }}
                                                disabled={isSubmitting}
                                            >
                                                Cancel
                                            </ButtonComponent>
                                            <ButtonComponent
                                                type="submit"
                                                color={"primary"}
                                                variant={"contained"}
                                                fullWidth={true}
                                                disabled={!isValid}
                                                isLoading={isSubmitting}
                                            >
                                                Download
                                            </ButtonComponent>
                                        </div>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </div>
                </DialogComponent>
            </div>
        </div>

    )

};

export default BarcodesListScreen;
